import { Divider, IconButton } from '@material-ui/core';
import { DateRange } from '@material-ui/icons';
import AddIcon from '@material-ui/icons/Add';
import EditIcon from '@material-ui/icons/Edit';
import { getCertificationById } from '@webapps/business';
import { Modal, useQuery } from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';
import PropTypes from 'prop-types';
import { useState } from 'react';
import { FormattedDate, FormattedMessage } from 'react-intl';

import AddCertification from './AddCertification';
import theme from './theme';

const {
  colors: { background, schoolNameColor },
} = theme;

const Certifications = ({ certifications = [], refetch }) => {
  const {
    classes,
    css,
    global,
    cx,
    theme: { spacing },
  } = useStyles(styles);

  const [addCertification, setAddCertification] = useState(false);
  const [editCertification, setEditCertification] = useState(false);
  const [idEdit, setIdEdit] = useState(null);

  const {
    data: certification = {},
    isLoading,
    refetch: fetchFormation,
  } = useQuery(getCertificationById, {
    key: ['CertificationProfilStudent', idEdit],
    variables: { id: idEdit },
    enabled: true,
  });

  const handleOpenAddCertification = () => {
    setAddCertification(true);
  };
  const handleCloseAddCertification = () => {
    setAddCertification(false);
  };

  const handleOpenEditCertification = () => {
    setEditCertification(true);
  };
  const handleCloseEditCertification = () => {
    setEditCertification(false);
    setIdEdit(null);
  };

  const openEdit = (id) => {
    setIdEdit(id);
    fetchFormation();
    handleOpenEditCertification();
  };

  return (
    <div className={classes.container}>
      <div className={classes.editContainer}>
        <div className={global.title}>
          <FormattedMessage id="student.profil.certification.title" />{' '}
          {certifications.length ? '(' + certifications.length + ')' : ''}
        </div>
        <div>
          <IconButton
            onClick={handleOpenAddCertification}
            size="small"
            style={{
              margin: 3,
              borderRadius: '20px',
              border: '1px solid #C0D9FF',
              backgroundColor: '#F3F7FF',
              width: '30px',
              display: 'flex',
              justifyContent: 'center',
              height: '30px',
              alignItems: 'center',
              cursor: 'pointer',
            }}
          >
            <AddIcon fontSize="small" style={{ color: '#5A6DA1' }} />
          </IconButton>
        </div>
      </div>
      {certifications?.length === 0 && (
        <div
          className={cx(css({
            textAlign: 'center',
            marginTop: spacing(2),
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            height: '190px',
          }), global.infoText)}
        >
          <FormattedMessage id="noElements" />
        </div>
      )}
      {certifications?.map(
        (
          { expirationDate, id, issueDate, issuingCompany, label, reference },
          index
        ) => (
          <>
            <div key={index} className={classes.educationContainer}>
              <div className={classes.educationDescription}>
                <div className={cx(global.title, classes.name)}>{label}</div>
                <div className={cx(global.infoText, classes.nameSchool)}>{issuingCompany}</div>
                <div className={cx(global.infoText, classes.address)}>{reference}</div>
                <div className={cx(global.infoText, classes.address)}>
                  <DateRange className={global.infoIcon} />
                  <FormattedDate
                    day="numeric"
                    month="long"
                    value={issueDate}
                    year="numeric"
                  />{' '}
                  au{' '}
                  <FormattedDate
                    day="numeric"
                    month="long"
                    value={expirationDate}
                    year="numeric"
                  />
                </div>
              </div>
              <div className={css({ marginLeft: 'auto' })}>
                <IconButton
                  onClick={() => openEdit(id)}
                  size="small"
                  style={{
                    margin: 3,
                    borderRadius: '20px',
                    border: '1px solid #C0D9FF',
                    backgroundColor: '#F3F7FF',
                    width: '30px',
                    display: 'flex',
                    justifyContent: 'center',
                    height: '30px',
                    alignItems: 'center',
                    cursor: 'pointer',
                  }}
                >
                  <EditIcon fontSize="inherit" style={{ color: '#5A6DA1' }} />
                </IconButton>
              </div>
            </div>
            {index !== certifications?.length - 1 && (
              <Divider className={css({ marginTop: spacing(1) })} />
            )}
          </>
        )
      )}
      <Modal
        onCancel={handleCloseAddCertification}
        open={addCertification}
        title={<FormattedMessage id="addCertification.title" />}
      >
        <AddCertification
          close={handleCloseAddCertification}
          refetch={refetch}
        />
      </Modal>
      <Modal
        onCancel={handleCloseEditCertification}
        open={editCertification}
        title={<FormattedMessage id="addCertification.titleEdit" />}
      >
        <AddCertification
          close={handleCloseEditCertification}
          idEdit={idEdit}
          initialData={certification}
          isLoadingEdit={isLoading}
          refetch={refetch}
        />
      </Modal>
    </div>
  );
};

const styles = ({ spacing }) => ({
  container: {
    background,
    flex: '1 1 0px',
    borderRadius: 10,
    padding: '20px',
    minHeight: 200,
    height: '100%',
    paddingBottom: spacing(2),
  },
  editContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  name: {
    display: 'flex',
    alignItems: 'center',
  },
  educationContainer: {
    display: 'flex',
    flexDirection: 'row',
    marginTop: spacing(2),
  },
  avatar: {
    height: 70,
    width: 70,
  },
  educationDescription: {
    display: 'flex',
    flexDirection: 'column',
  },
  nameSchool: {
    color: '#0060F9',
    display: 'flex',
    marginTop: spacing(0.5),
    alignItems: 'center',
  },
  address: {
    display: 'flex',
    alignItems: 'center',
    marginTop: spacing(1),  
  },
});

Certifications.propTypes = {
  certifications: PropTypes.array,
  refetch: PropTypes.func,
};

export default Certifications;
